import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CardsSection from './components/CardsSection';
import RankingSection from './components/RankingSection';
import ContactSection from './components/ContactSection';
import CarouselSection from './components/CarouselSection';
import MediaSection from './components/MediaSection';
import UpdatesSection from './components/UpdatesSection';
import AppSection from './components/AppSection';
import CommentsSection from './components/CommentsSection';
import FaqSection from './components/FaqSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import IndexSection from './components/IndexSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <CardsSection />
        <RankingSection />
        <ContactSection />
        <CarouselSection />
        <MediaSection />
        <UpdatesSection />
        <AppSection />
        <CommentsSection />
        <FaqSection />
        <TopicsSection />
        <FeaturesSection />
        <AboutSection />
        <IndexSection />
      </main>
      <Footer />
    </>
  );
}